import React from 'react'
import _ from 'lodash'
import { baseLink, defaultImageLink, FAST, GOOGLE } from './constants'

export const checkAge = (dob, AgeGate) => {
  const year = dob.slice(0, 4)
  const now = new Date()
  const gate = new Date()
  gate.setFullYear(now.getFullYear() - AgeGate)
  const isYoungLearner = year >= gate.getFullYear()
  return isYoungLearner
}

export const resultRenderer = ({ name, title, value, activity }) => {
  return (
    <>
      <strong>{name ?? title ?? activity?.name}</strong>
      <p>{value}</p>
    </>
  )
}

export const convertToOrdinal = (input) => {
  const nums = input.split('-')
  const start = parseInt(nums[0])
  const end = parseInt(nums[1])
  const output = []
  for (let i = start; i <= end; i++) {
    switch (i) {
      case 1:
        output.push(i + 'st')
        break
      case 2:
        output.push(i + 'nd')
        break
      case 3:
        output.push(i + 'rd')
        break
      default:
        output.push(i + 'th')
        break
    }
  }
  return output
}

export const convertOrdinalToNum = (arr) => {
  const res = []
  if (arr) {
    arr.forEach((val) => {
      if (val === 'K') res.push(0)
      else {
        res.push(+val.replace(/(\d+)(?:st|nd|rd|th)/g, '$1'))
      }
    })
  }
  return res
}

export const convertNumToOrdinal = (arr) => {
  const res = []
  if (arr) {
    arr.forEach(val => {
      if (val === 0) res.push('K')
      else {
        const j = val % 10
        const k = val % 100
        if (j === 1 && k !== 11) res.push(`${val}st`)
        else if (j === 2 && k !== 12) res.push(`${val}nd`)
        else if (j === 3 && k !== 13) res.push(`${val}rd`)
        else res.push(`${val}th`)
      }
    })
  }
  return res
}

export const getCollectionGrades = (_grade, filterGrades) => {
  const result = []
  const numberOfGrades = convertOrdinalToNum(_grade)
  numberOfGrades.forEach(numberOfGrade => {
    if (numberOfGrade > 2 && numberOfGrade < 6) {
      if (!result.includes(filterGrades[0])) {
        result.push(filterGrades[0])
      }
    }
    if (numberOfGrade > 5 && numberOfGrade < 9) {
      if (!result.includes(filterGrades[1])) {
        result.push(filterGrades[1])
      }
    }
    if (numberOfGrade > 8) {
      if (!result.includes(filterGrades[2])) {
        result.push(filterGrades[2])
      }
    }
  })
  return result
}

export const mapProductName = (input) => {
  switch (input) {
    case 'Mini':
      return 'Sphero Mini'
    case 'RVR':
      return 'RVR/RVR+'
    case 'Makerspace Invention Wall':
      return 'Makerspace Kit'
    case 'RVR+ Topper Kit':
      return 'RVR Topper Kit'
    default:
      return input
  }
}

export const formatDate = (dateString, prefs) => {
  const date = new Date(dateString)
  const yearAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 1))
  // We want this to be slightly less than a year otherwise something excatly a year ago will have today's date
  yearAgo.setDate(yearAgo.getDate() + 1)
  const options = { day: 'numeric', month: 'long' }
  if (date < yearAgo) {
    options.year = 'numeric'
  }
  return date.toLocaleDateString(prefs?.language || 'en', options)
}

export const formatDateByISO = (date) => {
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

export const filterItems = (items, key, query) => {
  return query ? items.filter(item => item[key].toLowerCase().includes(query.toLowerCase())) : items
}

export const customLabel = (label) => ({
  color: 'blue',
  content: label.text,
  style: { marginRight: '0.938rem' }
})

export const studentName = (student, code, classType) => {
  if (!student) return ''
  let name = [student.firstName, student.lastName].join(' ')
  if (classType === GOOGLE) {
    return `${student.email} (${name})`
  }
  if (classType !== FAST) {
    name += ` (${student.username})`
  } else {
    if (student.rosters?.length > 0) {
      student.rosters.forEach(r => {
        if (r.classroom.code === code && r.aliasStudentName?.length > 0) {
          name = r.aliasStudentName
        }
      })
    }
  }
  return name
}

export const containsSpace = (username) => {
  const hasSpace = /\s/
  return hasSpace.test(username.trim())
}

export const groupBy = (list, keyGetter) => {
  const map = new Map()
  list.forEach((item) => {
    const key = keyGetter(item)
    const collection = map.get(key)
    if (!collection) {
      map.set(key, [item])
    } else {
      collection.push(item)
    }
  })
  return map
}

export const defaultImage = (e) => {
  e.target.src = defaultImageLink
}

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const getImageSrc = data => {
  if (data.images && data.images.length > 0) return data.images[0].url || defaultImageLink
  if (data.imageUrl) return data.imageUrl.includes('http') ? data.imageUrl : `${baseLink}${data.imageUrl.replaceAll('%2F', '/')}`
  return defaultImageLink
}

export const checkIfSphero = str => {
  if (str.includes('BOLT') || str.includes('Sphero Mini') || str.includes('RVR/RVR+')) {
    return true
  } else {
    return false
  }
}

export const getBaseUrl = () => {
  // eslint-disable-next-line no-undef
  return window.location.origin + '/'
}

export const getYouTubeLink = (embedKey) => {
  return `https://www.youtube.com/embed/${embedKey}`
}

export const getTagOptions = (data) => {
  if (data && data.tags) {
    return _.map(data.tags.tags, (tag, index) => {
      if (tag.tagKey) {
        return {
          key: tag.tagKey + index,
          value: tag.name,
          text: tag.name
        }
      } else {
        return {
          key: tag.name + index,
          value: tag.name,
          text: tag.name
        }
      }
    })
  }
}

export const createActivityFromAssignment = (assignment) => {
  const steps = _.sortBy(assignment.activity.steps, step => step.position)
  const activity = { ...assignment.activity, steps }
  const _activity = {
    ...activity,
    assignment: {
      startedOn: assignment.startedOn,
      slug: assignment.slug,
      answers: assignment.tasks,
      id: assignment.id,
      progress: assignment.progress,
      user: assignment.user,
      createdAt: assignment.createdAt,
      completedOn: assignment.completedOn,
      acceptedOn: assignment.acceptedOn,
      program: assignment.program || activity.program
    }
  }
  return _activity
}

export const updateAnswers = (steps, tasks) => {
  const updatedSteps = steps.map(step => {
    const _step = { ...step }
    const studentAnswer = tasks.find(answer => +answer.step.id === +step.id)
    if (studentAnswer) {
      _step.studentAnswer = studentAnswer
    }
    return _step
  })
  return updatedSteps
}

// These two function for handling lists in Quill come from https://github.com/quilljs/quill/issues/979 and have been slightly modified
// Issue is that Quill does not properly format lists in a consistant way.
const getListLevel = (el) => {
  const className = el.className || '0'
  return +className.replace(/[^\d]/g, '')
}

export const convertLists = (richtext) => {
  const tempEl = window.document.createElement('div')
  tempEl.setAttribute('style', 'display: none')
  tempEl.innerHTML = richtext
  const listTypes = ['ul', 'ol']
  listTypes.forEach((type) => {
    const startTag = `::start${type}::::/start${type}::`
    const endTag = `::end${type}::::/end${type}::`
    // Grab each list, and work on it in turn
    Array.from(tempEl.querySelectorAll(type)).forEach((outerListEl) => {
      const listChildren = Array.from(outerListEl.children).filter((el) => el.tagName === 'LI')
      // Account for the fact that the first li might not be at level 0
      const firstLi = listChildren[0]
      firstLi?.before(startTag.repeat(getListLevel(firstLi)))

      // Now work through each li in this list
      listChildren.forEach((listEl, index) => {
        const currentLiLevel = getListLevel(listEl)
        if (index < listChildren.length - 1) {
          const difference = getListLevel(listChildren[index + 1]) - currentLiLevel

          // we only need to add tags if the level is changing
          if (difference > 0) {
            listChildren[index + 1].before(startTag.repeat(difference))
          } else if (difference < 0) {
            listEl.after(endTag.repeat(-difference))
          }
        } else {
          listEl.after(endTag)
        }
      })
      outerListEl.after(endTag)
    })
  })

  //  Get the content in the element and replace the temporary tags with new ones
  let newContent = tempEl.innerHTML
  newContent = newContent.replace(/::startul::::\/startul::/g, '<ul style="list-style-type:circle">')
  newContent = newContent.replace(/::endul::::\/endul::/g, '</ul>')
  newContent = newContent.replace(/::startol::::\/startol::/g, '<ol style="list-style-type:lower-latin">')
  newContent = newContent.replace(/::endol::::\/endol::/g, '</ol>')

  tempEl.remove()
  return newContent
}

// In case a user delted program 5 but not 6 make sure names don't match
const checkNumber = (count, data, programName) => {
  const testTitle = `${programName} (${count})`
  const found = _.find(data, p => p.title === testTitle)
  if (found) return checkNumber(count + 1)
  return testTitle
}

export const checkTitle = (data, programName) => {
  const regex = /\(.*\)/
  let count = 0
  data.forEach(program => {
    const match = program.title.match(regex)
    let oldTitle = program.title
    if (match) {
      oldTitle = program.title.replace(regex, '')
    }
    if (oldTitle.trim() === programName.trim()) count++
  })
  if (count === 0) return programName
  return checkNumber(count, data, programName)
}

export const getYouTubeGetID = (url) => {
  url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
  // eslint-disable-next-line
  return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0]
}

const gradeMapping = {
  'Pre-K': 0,
  K: 1,
  '1st': 2,
  '2nd': 3,
  '3rd': 4,
  '4th': 5,
  '5th': 6,
  '6th': 7,
  '7th': 8,
  '8th': 9,
  '9th': 10,
  '10th': 11,
  '11th': 12,
  '12th': 13,
  '12+': 14
}

export const compareGrades = (grade1, grade2) => {
  const val1 = gradeMapping[grade1]
  const val2 = gradeMapping[grade2]
  return val1 > val2
}

export const isSphero = (product) => {
  if (!product) return false
  else return !(product.toLowerCase().includes('blueprint') || product.toLowerCase().includes('indi') || product.toLowerCase().includes('littlebits'))
}

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find(key => object[key] === value)
}
